import { render, staticRenderFns } from "./EstatisticaSuperset.vue?vue&type=template&id=448861bc&"
import script from "./EstatisticaSuperset.vue?vue&type=script&lang=js&"
export * from "./EstatisticaSuperset.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticaSuperset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
